import { Button } from "lumir-back-office-ui";
import Spinner from "../../common/Spinner";

const Dialog = ({
  title,
  description,
  leftButtonText,
  rightButtonText,
  rightButtonOnClick,
  leftButtonOnClick,
  isLoading,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="relative rounded-lg w-[350px] bg-white p-[24px] space-y-[24px] shadow-lg">
        <div className="space-y-[16px]">
          {title && (
            <h3 className="typography-semantic-heading-2-bold">{title}</h3>
          )}
          {/* {isLoading && <Spinner size="lg" />} */}
          {description && (
            <p
              className="typography-semantic-body-1-reading---regular"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>
        <div className="flex justify-end gap-[16px]">
          <Button
            size="lg"
            variant="filled"
            state="secondary"
            className="min-w-[50px] h-[36px] cursor-none custom-cursor rounded-md"
            onClick={leftButtonOnClick}
            disabled={isLoading}
          >
            {leftButtonText}
          </Button>
          <Button
            size="lg"
            variant="filled"
            state="primary"
            className="min-w-[50px] h-[36px] cursor-none custom-cursor rounded-md"
            onClick={rightButtonOnClick}
            disabled={isLoading}
          >
            {rightButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Dialog;
